import { CommonMsgConst } from "../const/common-message-const";
import { CommonConst } from "../const/common-const";
import { MessageUtil } from './message-util';
import { HttpClient } from "@angular/common/http";
import { CommonStorageKey } from '../../shared';
import { IzonmojiModel } from "../data/izonmoji-model";
import { MessageKanriModel } from "../data/message-kanri-model";

export class ValidationUtil {

  // 強化テストNo178 start
  public static userIdHankakuList: Array<string> = new Array('-');
  // 強化テストNo178 end

  /**
   * 項目の背景色クリア処理
   */
  public static ClearBackgroundColor(elementId: string) {
    document.getElementById(elementId).style.backgroundColor = 'white';
  }

  /**
   * 項目の背景色設定処理
   */
  public static SetBackgroundColor(elementId: string) {
    document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
  }

  /**
   * 文字列の空白チェック(必須チェック)NoColor
   */
  public static isRequiredNoColor(inputValue: string, msgList: Array<string>, msgParam1: string, msgParam2: string = '入力'): Array<string> {
    if (this.isEmpty(inputValue)) {
      msgList.push(MessageUtil.getStorageMessage('N000001', [msgParam1, msgParam2, msgParam2])); // 課題No18
    }
    return msgList;
  }

  // 課題No18 start
  /**
   * 文字列の空白チェック(必須チェック)NoColor
   */
  public static isRequiredNoColorSpecify(inputValue: string, messageKanriList: MessageKanriModel[] = [], msgList: Array<string>, msgParam1: string, msgParam2: string = '入力'): Array<string> {
    if (this.isEmpty(inputValue)) {
      msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000001', [msgParam1, msgParam2, msgParam2]));
    }
    return msgList;
  }
  // 課題No18 end

  /**
   * 文字列の半角チェックNoColor
   */
  public static isHalfNoColor(inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (this.checkCharType(inputValue.charAt(i), 'zenkaku') && !this.checkCharType(inputValue.charAt(i), 'hkatakana')) {
        msgList.push(MessageUtil.getStorageMessage('N000002', [msgParam, '半角'])); // 課題No18
        break;
      }
    }
    return msgList;
  }

  // 課題No18 start
  /**
   * 文字列の半角チェックNoColor
   */
  public static isHalfNoColorSpecify(inputValue: string, messageKanriList: MessageKanriModel[] = [], msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (this.checkCharType(inputValue.charAt(i), 'zenkaku') && !this.checkCharType(inputValue.charAt(i), 'hkatakana')) {
        msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000002', [msgParam, '半角']));
        break;
      }
    }
    return msgList;
  }
  // 課題No18 end

  /**
   * 文字列の全角チェックNoColor
   */
  public static isZenkakuNoColor(inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (!(this.checkCharType(inputValue.charAt(i), 'zenkaku') || this.checkCharType(inputValue.charAt(i), 'hiragana')
        || this.checkCharType(inputValue.charAt(i), 'katakana'))) {
        msgList.push(MessageUtil.getStorageMessage('N000002', [msgParam, '全角'])); // 課題No18
        break;
      }
    }
    return msgList;
  }

  // 課題No18 start
  /**
   * 文字列の全角チェックNoColor
   */
  public static isZenkakuNoColorSpecify(elementId: string, inputValue: string, messageKanriList: MessageKanriModel[] = [], msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (!(this.checkCharType(inputValue.charAt(i), 'zenkaku') || this.checkCharType(inputValue.charAt(i), 'hiragana')
        || this.checkCharType(inputValue.charAt(i), 'katakana'))) {
        msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000002', [msgParam, '全角']));
        break;
      }
    }
    return msgList;
  }
  // 課題No18 end

  /**
   * 文字列の空白チェック(必須チェック)WithColor
   */
  public static isRequiredWithColor(elementId: string, inputValue: string, msgList: Array<string>, msgParam1: string, msgParam2: string = '入力'): Array<string> {
    if (this.isEmpty(inputValue)) {
      msgList.push(MessageUtil.getStorageMessage('N000001', [msgParam1, msgParam2, msgParam2])); // 課題No18
      document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
    }
    return msgList;
  }

  // 課題No18 start
  /**
   * 文字列の空白チェック(必須チェック)WithColor
   */
  public static isRequiredWithColorSpecify(elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgList: Array<string>, msgParam1: string, msgParam2: string = '入力'): Array<string> {
    if (this.isEmpty(inputValue)) {
      msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000001', [msgParam1, msgParam2, msgParam2]));
      document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
    }
    return msgList;
  }
  // 課題No18 end

  /**
   * 文字列の半角チェックWithColor
   * @param value チェック対象文字列
   * @returns true：半角です、false：半角ではない
   */
  public static isHalfWithColor(elementId: string, inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (this.checkCharType(inputValue.charAt(i), 'zenkaku') && !this.checkCharType(inputValue.charAt(i), 'hkatakana')) {
        msgList.push(MessageUtil.getStorageMessage('N000002', [msgParam, '半角'])); // 課題No18
        document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        break;
      }
    }
    return msgList;
  }

  // ST-491 注文番号に\"は入力不可 start
  /**
   * 文字列の半角チェックWithColor注文番号
   * @param value チェック対象文字列
   * @returns true：半角です、false：半角ではない
   */
  public static isHalfWithColorChumonno(elementId: string, inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if ((this.checkCharType(inputValue.charAt(i), 'zenkaku') && !this.checkCharType(inputValue.charAt(i), 'hkatakana'))
        || (inputValue.charAt(i) === "\\" || inputValue.charAt(i) === "\"")) {
        msgList.push(MessageUtil.getStorageMessage('N000020', [msgParam])); // 課題No18
        document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        break;
      }
    }
    return msgList;
  }
  // ST-491 注文番号に\"は入力不可 end

  // 課題No18 start
  /**
   * 文字列の半角チェックWithColor
   * @param value チェック対象文字列
   * @returns true：半角です、false：半角ではない
   */
  public static isHalfWithColorSpecify(elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (this.checkCharType(inputValue.charAt(i), 'zenkaku') && !this.checkCharType(inputValue.charAt(i), 'hkatakana')) {
        msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000002', [msgParam, '半角']));
        document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        break;
      }
    }
    return msgList;
  }
  // 課題No18 end

  // 強化テストNo383 start
  /**
   * 文字列の数値、半角ハイフンチェックWithColor
   * @param value チェック対象文字列
   * @returns true：半角数値または半角ハイフン、false：半角数値または半角ハイフンではない
   */
  public static isNumberOrHaihunWithColor(elementId: string, inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (!this.checkCharType(inputValue.charAt(i), 'numeric') && "-" != inputValue.charAt(i)) {
        msgList.push(MessageUtil.getStorageMessage('N000002', [msgParam, '半角数値または半角ハイフン']));
        document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        break;
      }
    }
    return msgList;
  }

  /**
   * 文字列の数値、半角ハイフンチェックWithColor
   * @param value チェック対象文字列
   * @returns true：半角カナ、false：半角カナではない
   */
  public static isNumberOrHaihunWithColorSpecify(elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (!this.checkCharType(inputValue.charAt(i), 'numeric') && "-" != inputValue.charAt(i)) {
        msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000002', [msgParam, '半角数値または半角ハイフン']));
        document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        break;
      }
    }
    return msgList;
  }
  // 強化テストNo383 end

  // 強化テストNo178 start
  /**
   * ユーザID用文字列チェックWithColor
   * @param value チェック対象文字列
   * @returns true：半角英数字(-含む)、false：半角英数字ではない
   */
  public static isHalfWithColorForUserId(elementId: string, inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (this.userIdHankakuList.indexOf(inputValue.charAt(i)) == -1) {
        if (!this.checkCharType(inputValue.charAt(i), 'alphanumeric')) {
          msgList.push(MessageUtil.getStorageMessage('N000002', [msgParam, '半角英数字'])); // 課題No18
          document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
          break;
        }
      }
    }
    return msgList;
  }
  // 強化テストNo178 end

  // 課題No18 start
  /**
   * ユーザID用文字列チェックWithColor
   * @param value チェック対象文字列
   * @returns true：半角英数字(-含む)、false：半角英数字ではない
   */
  public static isHalfWithColorForUserIdSpecify(elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (this.userIdHankakuList.indexOf(inputValue.charAt(i)) == -1) {
        if (!this.checkCharType(inputValue.charAt(i), 'alphanumeric')) {
          msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000002', [msgParam, '半角英数字']));
          document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
          break;
        }
      }
    }
    return msgList;
  }
  // 課題No18 end

  /**
   * 文字列の全角チェックWithColor
   * @param value チェック対象文字列
   * @returns true：全角です、false：全角ではない
   */
  public static isZenkakuWithColor(elementId: string, inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (!(this.checkCharType(inputValue.charAt(i), 'zenkaku') || this.checkCharType(inputValue.charAt(i), 'hiragana')
            ||this.checkCharType(inputValue.charAt(i), 'katakana'))
          || this.checkCharType(inputValue.charAt(i), 'hkatakana')) {
        msgList.push(MessageUtil.getStorageMessage('N000002', [msgParam, '全角'])); // 課題No18
        document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        break;
      }
    }
    return msgList;
  }

  // 課題No18 start
  /**
   * 文字列の全角チェックWithColor
   * @param value チェック対象文字列
   * @returns true：全角です、false：全角ではない
   */
  public static isZenkakuWithColorSpecify(elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (!(this.checkCharType(inputValue.charAt(i), 'zenkaku') || this.checkCharType(inputValue.charAt(i), 'hiragana')
        || this.checkCharType(inputValue.charAt(i), 'katakana'))
        || this.checkCharType(inputValue.charAt(i), 'hkatakana')) {
        msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000002', [msgParam, '全角']));
        document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        break;
      }
    }
    return msgList;
  }
  // 課題No18 end

  /**
   * 環境依存文字チェック
   * @param http
   * @param elementId
   * @param inputValue
   * @param msgParam
   */
  public static async izonmojiCheckAsync(http: HttpClient, elementId: string, inputValue: string, msgParam: string): Promise<boolean> {
    let izonmojiModel = new IzonmojiModel();
    sessionStorage.setItem(CommonStorageKey.MSGINFO, "");
    inputValue = (inputValue == null) ? "" : inputValue;
    if (inputValue != "") {
      izonmojiModel.inputValue = inputValue;
      return new Promise<boolean>(resolve => {
        http.post<IzonmojiModel>('/IzonmojiCheck', izonmojiModel).subscribe((result => {
          izonmojiModel = result[0];
          if (izonmojiModel.returnValue == false) {
            sessionStorage.setItem(CommonStorageKey.MSGINFO, MessageUtil.getStorageMessage('N000020', [msgParam])); // 課題No18
            document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
            resolve(true);
          } else {
            resolve(false);
          }
        }));
      });
    } else {
      return;
    }
  }

  // 課題No18 start
  /**
   * 環境依存文字チェック
   * @param http
   * @param elementId
   * @param inputValue
   * @param msgParam
   */
  public static async izonmojiCheckSpecifyAsync(http: HttpClient, elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgParam: string): Promise<boolean> {
    let izonmojiModel = new IzonmojiModel();
    sessionStorage.setItem(CommonStorageKey.MSGINFO, "");
    inputValue = (inputValue == null) ? "" : inputValue;
    if (inputValue != "") {
      izonmojiModel.inputValue = inputValue;
      return new Promise<boolean>(resolve => {
        http.post<IzonmojiModel>('/IzonmojiCheck', izonmojiModel).subscribe((result => {
          izonmojiModel = result[0];
          if (izonmojiModel.returnValue == false) {
            sessionStorage.setItem(CommonStorageKey.MSGINFO, MessageUtil.getMessageSpecify(messageKanriList, 'N000020', [msgParam]));
            document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
            resolve(true);
          } else {
            resolve(false);
          }
        }));
      });
    } else {
      return;
    }
  }
  // 課題No18 end

  /**
   * 半角数字チェック
   */
  public static isNumeric(elementId: string, inputValue: string, msgList: Array<string>, msgParam: string) {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (!this.checkCharType(inputValue.charAt(i), 'numeric')) {
        msgList.push(MessageUtil.getStorageMessage('N000003', [msgParam, '半角数字'])); // 課題No18
        document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        break;
      }
    }
    return msgList;
  }

  // 課題No18 start
  /**
   * 半角数字チェック
   */
  public static isNumericSpecify(elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgList: Array<string>, msgParam: string) {
    inputValue = (inputValue == null) ? "" : inputValue;
    for (let i = 0; i < inputValue.length; i++) {
      if (!this.checkCharType(inputValue.charAt(i), 'numeric')) {
        msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000003', [msgParam, '半角数字']));
        document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        break;
      }
    }
    return msgList;
  }
  // 課題No18 end

  /**
   * 日付チェック
   */
  public static isDateWithColor(elementId: string, inputValue: string, msgList: Array<string>, msgParam: string) {
    inputValue = (inputValue == null) ? "" : inputValue;
    if (this.isEmpty(inputValue)) {
      
    } else if (!this.checkCharType(inputValue, 'date')) {
      msgList.push(MessageUtil.getStorageMessage('N000003', [msgParam, '日付'])); // 課題No18
      document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
    }

    return msgList;
  }

  // 課題No18 start
  /**
   * 日付チェック
   */
  public static isDateWithColorSpecify(elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgList: Array<string>, msgParam: string) {
    inputValue = (inputValue == null) ? "" : inputValue;
    if (this.isEmpty(inputValue)) {

    } else if (!this.checkCharType(inputValue, 'date')) {
      msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000003', [msgParam, '日付']));
      document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
    }

    return msgList;
  }
  // 課題No18 end

  /**
  * 時間チェック
  */
  public static isTimeWithColor(elementId: string, inputValue: string, msgList: Array<string>, msgParam: string) {
    inputValue = (inputValue == null) ? "" : inputValue;
    if (this.isEmpty(inputValue)) {
      
    } else if (!this.checkCharType(inputValue, 'time')) {
      msgList.push(MessageUtil.getStorageMessage('N000003', [msgParam, '時間'])); // 課題No18
      document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
    }

    return msgList;
  }

  // 課題No18 start
  /**
    * 時間チェック
    */
  public static isTimeWithColorSpecify(elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgList: Array<string>, msgParam: string) {
    inputValue = (inputValue == null) ? "" : inputValue;
    if (this.isEmpty(inputValue)) {

    } else if (!this.checkCharType(inputValue, 'time')) {
      msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000003', [msgParam, '時間']));
      document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
    }

    return msgList;
  }
  // 課題No18 end

  /**
   * メールチェック
   */
  public static isMail(elementId: string, inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    if (!this.checkCharType(inputValue, 'mail')) {
      this.SetBackgroundColor(elementId);
      // ST-429 Start
      //msgList.push(MessageUtil.getStorageMessage('N000016', [msgParam])); // 課題No18
      if (msgParam !== '') {
        msgList.push(MessageUtil.getStorageMessage('N000016', [msgParam])); // 課題No18
      } else {
        msgList.push(MessageUtil.getStorageMessage('N503101'));
      }
      // ST-429 End
    }
    return msgList;
  }

  // 課題No18 start
  /**
   * メールチェック
   */
  public static isMailSpecify(elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgList: Array<string>, msgParam: string): Array<string> {
    inputValue = (inputValue == null) ? "" : inputValue;
    if (!this.checkCharType(inputValue, 'mail')) {
      this.SetBackgroundColor(elementId);
      msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000016', [msgParam]));
    }
    return msgList;
  }
  // 課題No18 start end

  /**
   * 郵便番号チェック
   */
  public static isPostWithColor(elementId: string, inputValue: string, msgList: Array<string>, msgParam: string, checkMode: boolean=true) {
    inputValue = (inputValue == null) ? "" : inputValue;
    if (this.isEmpty(inputValue)) {

    } else {
      if (checkMode) {
        if (!(this.checkCharType(inputValue, 'post7') || this.checkCharType(inputValue, 'post5'))) {
          msgList.push(MessageUtil.getStorageMessage('N000002', [msgParam, '123-4567形式'])); // 課題No18
          document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        }
      } else {
        if (!(this.checkCharType(inputValue, 'post7'))) {
          msgList.push(MessageUtil.getStorageMessage('N000002', [msgParam, '123-4567形式'])); // 課題No18
          document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        }
      }
    }
    return msgList;
  }

  // 課題No18 start
  /**
   * 郵便番号チェック
   */
  public static isPostWithColorSpecify(elementId: string, messageKanriList: MessageKanriModel[] = [], inputValue: string, msgList: Array<string>, msgParam: string, checkMode: boolean = true) {
    inputValue = (inputValue == null) ? "" : inputValue;
    if (this.isEmpty(inputValue)) {

    } else {
      if (checkMode) {
        if (!(this.checkCharType(inputValue, 'post7') || this.checkCharType(inputValue, 'post5'))) {
          msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000002', [msgParam, '123-4567形式']));
          document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        }
      } else {
        if (!(this.checkCharType(inputValue, 'post7'))) {
          msgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N000002', [msgParam, '123-4567形式']));
          document.getElementById(elementId).style.backgroundColor = CommonConst.C_ERROR_COLOR;
        }
      }
    }
    return msgList;
  }
  // 課題No18 end
  /**
   * 空白の判断
   * @param value
   */
  public static isEmpty(value: any): boolean {
    if (value == null || value === '' || value === undefined) {
      return true;
    } else {
      return false;
    }
  }

  // 課題No18 start
  /**
   * 共通メッセージ追加(メッセージ直接指定)
   */
  public static addCommonMessageSpecify(messageKanriList: MessageKanriModel[] = [], msgList: Array<string>) {
    let rtnMsgList: Array<string> = new Array<string>();
    if (msgList != null && msgList.length > 0) {
      rtnMsgList.push(MessageUtil.getMessageSpecify(messageKanriList, 'N999101'));
      for (let i = 0; i < msgList.length; i++) {
        rtnMsgList.push('　　' + msgList[i]);
      }
    }
    return rtnMsgList;
  }
  // 課題No18 end

  /**
   * 共通メッセージ追加
   */
  public static addCommonMessage(msgList: Array<string>): Array<string> {
    let rtnMsgList: Array<string> = new Array<string>();
    if (msgList != null && msgList.length > 0) {
      rtnMsgList.push(MessageUtil.getStorageMessage('N999101')); // 課題No18
      for (let i = 0; i < msgList.length; i++) {
        rtnMsgList.push('　　' + msgList[i]);
      }
    }
    return rtnMsgList;
  }

  public static checkCharType(input, charType) {
    switch (charType) {
      // 全角文字（ひらがな・カタカナ・漢字 etc.）
      case "zenkaku":
        // ST-391 Start
        //return (input.match(/^[^\x01-\x7E\xA1-\xDF]+$/)) ? true : false;
        return (input.match(/^[^\x01-\x7E\uFF61-\uFF9F]+$/)) ? true : false;
        // ST-391 End
      // 全角ひらがな
      case "hiragana":
        return (input.match(/^[\u3041-\u3096]+$/)) ? true : false;
      // 全角カタカナ
      case "katakana":
        return (input.match(/^[\u30a1-\u30f6]+$/)) ? true : false;
      // 半角カタカナ
      case "hkatakana":
        return (input.match(/^[ｦ-ﾟ]*$/)) ? true : false;
      // 半角英数字（大文字・小文字）
      case "alphanumeric":
        return (input.match(/^[0-9a-zA-Z]+$/)) ? true : false;
      // 半角数字
      case "numeric":
        return (input.match(/^[0-9]+$/)) ? true : false;
      // 半角英字（大文字・小文字）
      case "alphabetic":
        return (input.match(/^[a-zA-Z]+$/)) ? true : false;
      // 半角英字（大文字のみ）
      case "upper-alphabetic":
        return (input.match(/^[A-Z]+$/)) ? true : false;
      // 半角英字（小文字のみ）
      case "lower-alphabetic":
        return (input.match(/^[a-z]+$/)) ? true : false;
      case "mail":
        return (input.match(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i)) ? true : false;
      case "date":
        return (input.match('(([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})\\/(((0[13578]|1[02])\\/(0[1-9]|[12][0-9]|3[01]))|' +
              '((0[469]|11)\\/(0[1-9]|[12][0-9]|30))|(02\\/(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|' +
          '((0[48]|[2468][048]|[3579][26])00))\\/02\\/29)$')) ? true : false;
      // 時間
      case "time":
        return (input.match(/^(0?[0-9]|1[0-9]|2[0-3]):(0?[0-9]|[1-5][0-9])$/)) ? true : false;
      case "post7":
        return (input.match(/^\d{3}-\d{4}$/)) ? true : false;
      case "post5":
        return (input.match(/^\d{3}-\d{2}$/)) ? true : false;
      case "hkigou":
        return (input.match(/^[ -/:-@\[-~]+$/)) ? true : false;
    }
    return false;
  }

  /**
   * 日付ＴＯ－日付ＦＲＯＭ（指定できる日付の範囲)＞１か月の判断
   * @param hizukefrom
   * @param hizuketo
   */
  public static checkDate(hizukefrom: string, hizuketo: string): boolean {
    const dateFrom: Date = new Date(hizukefrom);
    const dateTo: Date = new Date(hizuketo);
    if (dateFrom.getFullYear() === dateTo.getFullYear()) {
      if (dateTo.getMonth() - dateFrom.getMonth() > 1) {
        return false;
      } else if (dateTo.getMonth() - dateFrom.getMonth() === 1) {
        if (dateTo.getDate() > dateFrom.getDate()) {
          return false;
        }
      }
    } else {
      if (dateTo.getFullYear() - dateFrom.getFullYear() > 1) {
        return false;
      } else if (dateTo.getFullYear() - dateFrom.getFullYear() === 1) {
        if (dateTo.getMonth() > 0) {
          return false;
        } else {
          if (dateFrom.getMonth() < 11) {
            return false;
          } else {
            if (dateTo.getDate() > dateFrom.getDate()) {
              return false;
            }
          }
        }
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/utility/validation-util.ts